import 'babel-polyfill'
import 'web-animations-js'
import smoothscroll from 'smoothscroll-polyfill';

// kick off the polyfill!
smoothscroll.polyfill();
// Service-workers for offline capabilities
// import * as OfflinePluginRuntime from 'offline-plugin/runtime';

// import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from 'axios'
import VueAxios from 'vue-axios'
// import VueAnalytics from 'vue-analytics'
import VueGtm from 'vue-gtm'

/*
    Usage of Web Worker --
    Try and use this to do background data updates
    on another THREAD!!
 */

// import VueWorker from 'vue-worker'
// Vue.use(VueWorker)
Vue.config.devtools = true;

// PLUGINS
import VuePaginate from 'vue-paginate'
import AsyncComputed from 'vue-async-computed'
// import VueKinesis from 'vue-kinesis'

// Vue.use(VueKinesis)
Vue.use(VueAxios, axios)

Vue.use(VuePaginate)
Vue.use(AsyncComputed)

/*
    // ROUTER & VUEX (store)
*/
import routes from './routes'
import { store } from './store/index.js';


// API OPTIONS
axios.defaults.baseURL = '/wsMain.asmx'

Vue.use(VueRouter);

export const router = new VueRouter(routes);

Vue.use(VueGtm, {vueRouter: router })
// Vue.use(VueAnalytics, {
//     id: 'UA-24075100-9',
//     router
// })

/*
    // SYNC THEM (Router & Vuex)
*/
import { sync } from 'vuex-router-sync';
sync(store, router);

/*
    // Styles
*/
import './styl/app.styl';
import App from './ui/layout/App.vue';

/*
    // Start App
*/
// OfflinePluginRuntime.install();
// if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.register('/dist/sw.js')
//     .then(function(reg) {
//         // registration worked
//         console.log('Registration succeeded. Scope is ' + reg.scope);
//     }).catch(function(error) {
//         // registration failed
//         console.log('Registration failed with ' + error);
//     });
// }

var root = new Vue({
    router,
    store,
    render: h => h(App),
    // mounted() {
    //     this.$store.watch(state => this.$store.state.cart, c => {
    //         console.log('watched: ', c)
    //     })
    // }
});

document.addEventListener('DOMContentLoaded', function () {
    if (process.env.NODE_ENV==='production') {

        let loc = window.location,
            protocol = loc.protocol,
            host = loc.host,
            pathname = loc.pathname;
        if (!/https/.test(protocol) && !/local/.test(host)) {
            window.location = `https://${host}${pathname}`;
        } else {
            root.$mount('#app');
        }
    }
    else {
        root.$mount('#app');

    }
})


/*
    // POLYFILLS <<
*/

// Custom Event
function globalCustomEventPoly() {

    if ( typeof window.CustomEvent === "function" ) return false;

    function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
}


// Element Closest
if (!Element.prototype.matches)
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
                                Element.prototype.webkitMatchesSelector;

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;
        if (!document.documentElement.contains(el)) return null;
        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}